import { render, staticRenderFns } from "./LegalSettlements.vue?vue&type=template&id=2c2bf055&scoped=true"
import script from "./LegalSettlements.vue?vue&type=script&lang=js"
export * from "./LegalSettlements.vue?vue&type=script&lang=js"
import style0 from "./LegalSettlements.vue?vue&type=style&index=0&id=2c2bf055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2bf055",
  null
  
)

export default component.exports